import {Check, X, Save, Home, Download} from 'lucide-react'
import sidebarlogo from '../../assets/img/sidebarlogo.svg'

export const IngresoPromocionTradicionalRightMenu = ({onApprovePending, onRejectPending, onSave, onHome}) => {
	return (
		<aside className='IngresoPromocionTradicionalRightMenu'>
			<button type='button' title='Aprobar pendientes' className='traditional-side-button approve' onClick={onApprovePending}>
				<Check size={18} strokeWidth={3} />
			</button>
			<button type='button' title='Rechazar pendientes' className='traditional-side-button reject' onClick={onRejectPending}>
				<X size={18} strokeWidth={3} />
			</button>
			<div className='traditional-side-separator' />
			<button type='button' title='Guardar' className='traditional-side-button' onClick={onSave}>
				<Save size={18} />
			</button>
			<button type='button' title='Inicio' className='traditional-side-button' onClick={onHome}>
				<Home size={18} />
			</button>
			<button type='button' title='Exportar' className='traditional-side-button'>
				<Download size={18} />
			</button>
			<img src={sidebarlogo} alt='Promobooster' className='traditional-side-logo' />
		</aside>
	)
}
